import { Component, OnInit } from '@angular/core';
import { Globals } from 'src/app/shared/globals/globals';
import { BackendService } from 'src/app/shared/services/backend/backend.service';
import { UtilsService } from 'src/app/shared/services/utils/utils.service';
import { ColumnWidth, GridConfiguration } from 'src/app/shared/teiasoft-bucket/teiasoft-grid-odata/teiasoft-grid-odata.component';
import { TTButton } from 'src/app/shared/teiasoft-bucket/teiasoft-toolbar/teiasoft-toolbar.component';

@Component({
  selector: 'app-logs',
  templateUrl: './logs.component.html',
  styleUrls: ['./logs.component.scss']
})
export class LogsComponent implements OnInit {
  buttonsList: TTButton[] = new Array();
  gridFilterable: boolean = false;
  clearFilters: boolean = false;
  columnsToHide: string[] = ["Id"];
  oDataUrl: string = "Logs";
  gridConfiguration: GridConfiguration = new GridConfiguration();
  refreshGridKey: number = 0;
  showSettingsDialog: boolean = false;
  columnsWidth: ColumnWidth[] = new Array();

  constructor(public globals: Globals, private backendService: BackendService, private utils: UtilsService) {
    this.checkUserConfiguration();
    this.setColumnsWidth();
  }

  ngOnInit(): void {

  }

  // Sert column Width
  setColumnsWidth() {
    this.columnsWidth = new Array();
    let _col: ColumnWidth = new ColumnWidth();
    _col.colName = "Description";
    _col.length = 200;
    _col.width = 200;
    this.columnsWidth.push(_col);
  }

  /**
   * CHECK USER GRID CONFIGURATION
   */
  checkUserConfiguration() {
    this.gridConfiguration = new GridConfiguration();
    const userConfiguration = this.utils.getUserConfiguration();
    const savedConfiguration = userConfiguration.gridsConfigurations?.find(cfg => cfg.name === 'Logs');

    if (savedConfiguration) {
      this.gridConfiguration = savedConfiguration;
    } else {
      this.gridConfiguration = new GridConfiguration();
      this.gridConfiguration.name = 'Logs';
      this.gridConfiguration.defaultFilterView = '';
    }

    /* BUILD BUTTONS FOR TOOLBAR */
    this.buildButtonsList();
  }

  updateUserConfiguration() {
    this.backendService.updateUserConfiguration(this.globals.userLogged!.configuration!, this.globals.userLogged!.language!, this.globals.userLogged!.dateFormat!).subscribe(res => {
      // HI - 7/12/2023 - Rif. MQF-03 - Commentato
      //this.teiasoftToaster.show("success", this.translate.instant("commons.success"));
      // END MQF-03
    });
  }

  refreshFullGrid() {
    this.refreshGridKey++;
  }

  /**
   * TOOLBAR BUTTONS LIST
   */
  buildButtonsList() {
    this.buttonsList = new Array();
    let _item: TTButton = new TTButton();
    /* EDIT GRID */
    _item = new TTButton();
    _item.disabled = false;
    _item.icon = 'fal fa-wrench';
    _item.id = 4;
    _item.size = "";
    _item.text = "";
    _item.tooltip = "editGrid";
    _item.action = "showSettingsGrid";
    _item.type = "";
    _item.state = '';
    this.buttonsList.push(_item);

    /* SHOW/HIDE FILTER */
    _item = new TTButton();
    _item.disabled = false;
    _item.icon = !this.gridFilterable ? 'fal fa-filter' : 'fal fa-filter-circle-xmark';
    _item.id = 5;
    _item.size = "";
    _item.text = "";
    _item.tooltip = !this.gridFilterable ? "showGridFilters" : "hideGridFilters";
    _item.action = !this.gridFilterable ? "showFilter" : "closeFilter";
    _item.type = "";
    _item.state = this.gridFilterable ? 'pressed' : '';
    this.buttonsList.push(_item);

    /* CLEAR FILTERS */
    _item = new TTButton();
    _item.disabled = !this.gridFilterable ? true : false;
    _item.icon = 'fal fa-eraser';
    _item.id = 6;
    _item.size = "";
    _item.text = "";
    _item.tooltip = "clearGridFilters";
    _item.action = "clearFilter";
    _item.type = "";
    _item.state = '';
    this.buttonsList.push(_item);
  }

  onUpdateConfiguration(gridConfiguration: GridConfiguration) {
    this.utils.upsertGridConfiguration(gridConfiguration);
    this.updateUserConfiguration();
  }

  /***************************************** EVENTS **************************************************/
  /**
   * Toolbar Buttons Click Events
   * @param btn 
   */
  onBtnToolbarClick(btn: TTButton) {
    /* SHOW SETTINGS GRID */
    if (btn.action == 'showSettingsGrid') {
      this.showSettingsDialog = true;
    }

    /* SHOW FILTER */
    if (btn.action == 'showFilter') {
      this.gridFilterable = true;
      this.buildButtonsList();
    }

    /* CLOSE FILTER */
    if (btn.action == 'closeFilter') {
      this.gridFilterable = false;
      this.buildButtonsList();
    }

    /* CLEAR FILTER */
    if (btn.action == 'clearFilter') {
      this.clearFilters = true;
      setTimeout(() => { this.clearFilters = false }, 250);
      this.refreshFullGrid();
    }

  }
}
